import { render } from "./fb2.vue?vue&type=template&id=5ed38d2e&scoped=true"
import script from "./fb2.vue?vue&type=script&lang=js"
export * from "./fb2.vue?vue&type=script&lang=js"

import "./fb2.vue?vue&type=style&index=0&id=5ed38d2e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed38d2e"]])

export default __exports__